export const OverlayLayers = {
  NONE: '',
  INFO: 'info',
  SEARCH: 'search',
  FILTERS: 'filters',
}
